import { bind } from 'bind-decorator';
import _ from 'lodash';
import React from 'react';
import Buttons from './components/buttons';
import Maitland from './components/maitland';
import QuickPick from './components/quick-pick';

class Picker extends React.Component {
  static flattenRegex = /\r?\n|\r/g;
  static scrollIntoViewOptions = {
    behavior: 'smooth',
    block: 'center',
    inline: 'center'
  };

  static defaultProps = {
    focus: () => null,
    onChange: () => null
  };

  picker = React.createRef();

  get isButtons() {
    const { src } = this.props;

    return _.isString(src) && src.length > 0;
  }

  get isQuickpick() {
    const { src } = this.props;
    const isArray = _.isArray(src);

    return (!isArray && _.isObject(src)) || (isArray && src.length > 0);
  }

  scrollIntoView(override) {
    const { current: picker } = this.picker;
    if (!picker) {
      return;
    }

    const options = override != null ? override : Picker.scrollIntoViewOptions;
    picker.scrollIntoView(options);
  }

  @bind
  onInsert(val, key, e) {
    let { mode, value, appendMode, maitland } = this.props;

    // For Maitland keyboard, insert at cursor position
    if (maitland && typeof val === 'string' && val.length === 1) {
      const el = document.activeElement as HTMLInputElement | HTMLTextAreaElement;
      if (el && 'value' in el && 'selectionStart' in el) {
        const start = el.selectionStart || 0;
        const end = el.selectionEnd || 0;
        el.value = el.value.substring(0, start) + val + el.value.substring(end);

        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));

        setTimeout(() => {
          el.focus();
          el.setSelectionRange(start + 1, start + 1);
        }, 0);

        return;
      }
    }

    if (this.props['full-lookup-path'] && this.props.src.main) {
      let menu = this.props.src;
      let str = key;
      let v = '';
      let prefixIndex = 0;
      while (prefixIndex > -1 && str != 'main') {
        prefixIndex = _.lastIndexOf(str, '.');
        let prefix = str.substring(0, prefixIndex);
        let item = menu[prefix][str];
        item = typeof item === 'object' ? item.description : item;
        v = item + (v != '' ? ' > ' + v : '');
        str = prefix;
      }
      val = v;
    }

    if (!!val) {
      val = typeof val === 'object' ? val.description : val;
    }

    val = val.replace(Picker.flattenRegex, ' ');
    let operator = {
      space: () => {
        return ' ';
      },
      newline: () => {
        return value === '' ? ' ' : '\n ';
      },
      newlinedash: () => {
        return value === '' ? ' - ' : '\n - ';
      },
      comma: () => {
        if (!value) {
          return '';
        }
        return value.test(Picker.commaRegex) ? ' ' : ', ';
      }
    };

    if (appendMode) appendMode = appendMode.toLowerCase().replace(/ /g, '');

    let operation = operator[appendMode];
    val = `${!!operation ? operation() : ''}${val}`;
    let res = mode !== 'single' && !!value ? `${value || ''}${val}` : val;

    this.props.onChange(res);
    this.props.focus();
  }

  UNSAFE_componentWillMount() {
    this.scrollIntoView = this.scrollIntoView.bind(this);

    this.onInsert = this.onInsert.bind(this);
  }

  shouldComponentUpdate(props) {
    if (this.props.open !== props.open) {
      return true;
    }

    return false;
  }

  render() {
    if (!this.props.open) {
      return <></>;
    }

    const { maitland } = this.props;
    let element = null;

    if (this.isQuickpick) {
      element = (
        <QuickPick
          appendMulti={this.props.appendMulti}
          menu={this.props.src}
          open={this.props.open}
          onChange={this.onInsert}
          onRequestClose={this.props.onRequestClose}
        />
      );
    } else if (this.isButtons) {
      element = (
        <Buttons
          mode={this.props.mode}
          separator={this.props.separator}
          src={this.props.src}
          style={this.props.buttonStyle}
          value={this.props.value}
          onChange={this.props.onChange}
          onSet={this.props.onRequestClose}
        />
      );
    } else if (maitland) {
      element = <Maitland hide={this.props.hide} onClick={this.onInsert} />;
    }

    if (!element) {
      return <></>;
    }

    return <div ref={this.picker}>{element}</div>;
  }
}

export default Picker;
